export const TextNameSection = ({ value = "" }) => {
  const sections = value.split("(");
  return sections.length > 1 ? <>{` ${sections[0]} \n (${sections[1]}`}</> : <> {value}</>;
};

export default TextNameSection;
